// ORDER-TYPE-EXCEPTION-CRUD
// Order types an exception can be added with or edited to; `code` is the matching cndn_remarks_code_int.
export const editableOrderTypes = [
  { label: "RO - Regular Order", value: "RO", code: 1 },
  { label: "SAO-NP - Supply Against Order - No Replenishment", value: "SAO-NP", code: 2 },
  { label: "CN-NP - Credit Note - No Replenishment", value: "CN-NP", code: 3 },
  { label: "POB", value: "POB", code: 4 },
];

// `name` is what the corp bulk validation expects in the `module` column.
export const moduleOptions = [
  { label: "Medvol", value: 1, name: "MEDVOL" },
  { label: "POB", value: 4, name: "POB" },
];
// ORDER-TYPE-EXCEPTION-CRUD
